export default function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">{subtitle}</div>
        <h1 className="text-2xl font-display font-bold text-slate-900 tracking-tight">{title}</h1>
      </div>
      {right}
    </div>
  );
}
